export class DenreeQuantiteModel {
  idProduitDeclinaison: number;
  quantiteUT: number;
}
